module.exports = __webpack_public_path__ + "static/media/subaru.1ac5f3d4.png";